import type { AppModuleCustomPricingSchemaBulkInsertResponse } from "@classes-service-types/index.ts";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { learningServiceRequest } from "@/services/utils";
import { QUERY_KEY } from "./useGetCustomPricingList";

export const useInsertCustomPricing = (
  useMutationOptions?: UseMutationOptions<AppModuleCustomPricingSchemaBulkInsertResponse, Error, File>,
) => {
  const queryClient = useQueryClient();

  return useMutation<AppModuleCustomPricingSchemaBulkInsertResponse, Error, File>({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append("file", file);
      const response: AxiosResponse<AppModuleCustomPricingSchemaBulkInsertResponse> = await learningServiceRequest({
        method: "post",
        url: "/custom_pricing/bulk_insert/",
        payload: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
    ...useMutationOptions,
  });
};
